<template>
  <v-container fluid>
    <div class="flex-col-start-start gap-4">
      <div class="flex-row-between-center w-100">
        <HistoryFilter
          :filterData="filter"
          :loading="filterLoading"
          @filter="handleFilter"
        />
        <HistoryExport
          title="Balance"
          :filterData="filter"
          :exportData="exportData"
          :disabled="balanceHistory.length === 0"
        />
      </div>
      <Loader v-if="loading" />
      <NoRecord v-else-if="balanceHistory.length === 0" />
      <div class="flex-col-start-start gap-2 w-100" v-else>
        <BalanceHistoryCard
          v-for="balanceData in balanceHistory"
          :key="balanceData.time"
          :balanceData="balanceData"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import HistoryFilter from "@/components/lists/HistoryFilter.vue";
import HistoryExport from "@/components/lists/HistoryExport.vue";
import NoRecord from "@/components/lists/NoRecord.vue";
import Loader from "@/components/lists/Loader.vue";
import BalanceHistoryCard from "./fragments/history.card.vue";
import { GET_BALANCE_HISTORY } from "@/core/services/store/modules/balance/balance.module";
import moment from "jalali-moment";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "BalanceHistory",

  data() {
    return {
      loading: false,
      filterLoading: false,
      filter: {
        created_at_from: undefined,
        created_at_to: undefined,
        limit: undefined,
      },
      rawData: [],
    };
  },

  computed: {
    ...mapGetters(["balanceHistory"]),
    exportData() {
      const KeyMap = {
        A: "pg water discharge",
        B: "png water discharge",
        C: "bustle dry percentage composition",
      };
      const headers = ["time"];
      let data = this.rawData.map((balance) => ({
        time: moment(new Date(balance.created_at)).format(
          "jYYYY/jMM/jDD hh:mm"
        ),
      }));

      this.rawData.forEach((balance, index) => {
        Object.entries(balance.output).forEach(([key, value]) => {
          if (["A", "B", "C"].includes(key)) {
            Object.entries(value).forEach(([code, val]) => {
              const name = `${KeyMap[key]} ${code}`;
              if (!headers.includes(name)) headers.push(name);
              data[index] = { ...data[index], [name]: val };
            });
          } else {
            const name = key.replaceAll("_", " ");
            if (!headers.includes(name)) headers.push(name);
            data[index] = { ...data[index], [name]: value };
          }
        });
        // Object.entries(balance.natural_gas).forEach(([key, value]) => {
        //   const name = `Natural Gas ${key.replaceAll("_", " ")}`;
        //   // const name = key.replaceAll("_", " ");
        //   if (!headers.includes(name)) headers.push(name);
        //   data[index] = { ...data[index], [name]: value };
        // });
      });

      return { headers, data };
    },
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.filterLoading = true;
      const {
        data: { data: rawData },
      } = await this.$store
        .dispatch(GET_BALANCE_HISTORY, this.filter)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.loading = false;
          this.filterLoading = false;
        });
      if (rawData) this.rawData = rawData;
    },
    handleFilter({ key, value }) {
      this.filter = { ...this.filter, [key]: value };
    },
  },

  watch: {
    filter: async function (value) {
      this.filterLoading = true;
      const {
        data: { data: rawData },
      } = await this.$store
        .dispatch(GET_BALANCE_HISTORY, value)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.filterLoading = false;
        });
      if (rawData) this.rawData = rawData;
    },
  },

  components: {
    HistoryFilter,
    HistoryExport,
    NoRecord,
    Loader,
    BalanceHistoryCard,
  },
};
</script>
